// import * as mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
import 'mapbox-gl/dist/mapbox-gl.css';
import * as React from 'react';
import { useState } from 'react';
import Map, { Marker } from 'react-map-gl';
import '../../css/style.css';
import serverData from "../../data/sensorData.json";
import serverStatus from "../../data/defaultStatus.json"
// @ts-ignore
// eslint-disable-next-line import/no-webpack-loader-syntax
// mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const MAPBOX_TOKEN = "pk.eyJ1Ijoic2FiaXJiZCIsImEiOiJja3p0dnprd2o0cHk1MnFucnN3Mjd6ZHVjIn0.VNO2zEilV3w7Xu9DB6Tr3w";

const MapLayout = ({ groupId, long, lat, currentData, currentStatus }) => {
    let latestData = currentData.length ? currentData[currentData.length - 1] : serverData[0];
    const lastUpdate = new Date(latestData.ts).toLocaleString();
    let lastUpdateTS = new Date(latestData.ts);
    let lastUpdateUnixTS = Math.floor(lastUpdateTS / 1000);
    lastUpdateUnixTS = Math.floor(lastUpdateTS / 1000);
    let currentTime = new Date();
    let currentUnixTS = Math.floor(currentTime / 1000);
    currentUnixTS = Math.floor(currentTime / 1000);
    latestData = latestData.data?.[0] ?? serverData[0]
    const direction = `rotate(${latestData.d}deg)`;

    let lastStatus = currentStatus.length ? currentStatus[0] : serverStatus[0];
    // Debugging: (following 6 lines)
    //console.log("latestData:");
    //console.log(latestData);
    //console.log("lastStatus:");
    //console.log(lastStatus.status);
    //if (lastStatus.sensor_id === undefined) { console.log("Sensor undefined"); }
    //else { console.log("Got sensor_id: ");console.log(lastStatus.sensor_id); }

    let badmsg="";
    if (lastStatus.p !== undefined) { badmsg=lastStatus.p; }
    if (lastStatus.t !== undefined) { if (badmsg==="") { badmsg=lastStatus.t; } else { badmsg=badmsg+", "+lastStatus.t; } }
    if (lastStatus.v !== undefined) { if (badmsg==="") { badmsg=lastStatus.v; } else { badmsg=badmsg+", "+lastStatus.v; } }
    if (lastStatus.d !== undefined) { if (badmsg==="") { badmsg=lastStatus.d; } else { badmsg=badmsg+", "+lastStatus.d; } }
    if (lastStatus.dp !== undefined) { if (badmsg==="") { badmsg=lastStatus.dp; } else { badmsg=badmsg+", "+lastStatus.dp; } }
    if (lastStatus.wl !== undefined) { if (badmsg==="") { badmsg=lastStatus.wl; } else { badmsg=badmsg+", "+lastStatus.wl; } }
    if (lastStatus.discharge !== undefined) { if (badmsg==="") { badmsg=lastStatus.discharge; } else { badmsg=badmsg+", "+lastStatus.discharge; } }
    if (lastStatus.at !== undefined) { if (badmsg==="") { badmsg=lastStatus.at; } else { badmsg=badmsg+", "+lastStatus.at; } }
    if (lastStatus.ap !== undefined) { if (badmsg==="") { badmsg=lastStatus.ap; } else { badmsg=badmsg+", "+lastStatus.ap; } }


    const latitude = long; //place?.geometry?.coordinates[0];
    const longitude = lat; // place?.geometry?.coordinates[1]

    const [viewPort, setViewport] = useState({
        longitude: long,
        latitude: lat,
        zoom: 10
    });
    React.useEffect(()=>{
        setViewport({
            longitude: long,
            latitude: lat,
            zoom: 10
        })
    },[groupId,long,lat])
    return (
        <div className='map-layout'>

            <Map
                {...viewPort}
                mapStyle="mapbox://styles/mapbox/streets-v9"
                style={{ width: '100%', height: '60vh' }}
                mapboxAccessToken={MAPBOX_TOKEN}
                onMove={vp => setViewport(vp)}
            >


                <Marker
                    key={groupId}
                    longitude={long}
                    latitude={lat}
                    
                >
                    <button
                        className='marker-btn'
                        // style={{ }}
                        onClick={(e) => {
                            e.preventDefault();
                        }
                        }
                    >
                        {groupId}
                    </button>
                </Marker>
                ))

            </Map>
            <div className='data-panel'>
                <ul>
                    {lastUpdateUnixTS < 1000000 &&
                     <li key={5}>No connection?</li>
                    }
                    {currentUnixTS - lastUpdateUnixTS < 1800 &&
                     <li key={5}>Connection ok</li>
                    }
                    {(currentUnixTS - lastUpdateUnixTS >= 1800)&&(lastUpdateUnixTS>=1000000) &&
                     <li key={5}>May be disconnected</li>
                    }
                     <li key={1}>Last update: {lastUpdate ?? "-1"}</li>
                     <li key={2}>Current velocity: {latestData.v?.toFixed(3) ?? "-1"} m/s </li>
                     <li key={3}>Current Pressure: {latestData.p?.toFixed(3 ?? "-1")} mbar </li>
                     <li key={4}>{latestData.d?.toFixed(3) ?? "-1"} Degree from North </li>
                     <li key={6}>Notice: {lastStatus.status}</li>
                    {lastStatus.sensor_id !== undefined &&
                     <li key={7}><font color="red">Sensor: {lastStatus.sensor_id} ({badmsg})</font></li>
                    }
                </ul>
                <div className='compass-div'>
                    <div className='compass-container'>
                        <img className='compass-container--scale' src="/compass.png" alt="compass" />
                        <img className="compass-container--dial" style={{ transform: direction }} src="/kata.png" alt="dial" />
                    </div>
                </div>
            </div>
        </div>


    );
};

export default MapLayout;
